import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { adminAPI } from '../services/api';
import GrantForm from '../components/forms/GrantForm';

const GrantFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;

  const [formData, setFormData] = useState({
    name: '',
    amount: '',
    category: '',
    deadline: '',
    status: 'Open'
  });

  const [submitting, setSubmitting] = useState(false);

  // Load grant in edit mode
  useEffect(() => {
    if (isEditMode) {
      const loadGrant = async () => {
        try {
          const grant = await adminAPI.getGrantById(id);

          setFormData({
            ...grant,
            deadline: grant.deadline
              ? grant.deadline.slice(0, 10)
              : ''
          });

        } catch (error) {
          console.error('Error loading grant:', error);
          toast.error('Failed to load grant data');
          navigate('/admin/dashboard');
        }
      };

      loadGrant();
    }
  }, [id, isEditMode, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
        // Prepare payload properly
        const payload = {
        name: formData.name,
        amount: String(formData.amount),
        category: formData.category,
        status: formData.status,
        deadline: formData.deadline
            ? new Date(formData.deadline).toISOString()
            : null
        };

        if (isEditMode) {
        await adminAPI.updateGrant(id, payload);
        toast.success('Grant updated successfully');
        } else {
        await adminAPI.createGrant(payload);
        toast.success('Grant created successfully');
        }

        navigate('/admin/dashboard');
    } catch (error) {
      console.error('Error saving grant:', error);
      const errorMessage =
        error.response?.data?.detail ||
        error.message ||
        'Failed to save grant';

      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/dashboard');
  };

  return (
    <div className="container mx-auto p-6">
      <GrantForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        submitting={submitting}
        isEdit={isEditMode}
      />
    </div>
  );
};

export default GrantFormPage;